function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "R LOGO SVG WHITE@svg@svg");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Marketing-pages",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "R-LOGO-SVG-WHITE@svg",
  transform: "translate(0.000000, -1.000000)",
  fill: "#80A1FE",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.185,43.925 C50.063,38.213 52.688,29.893 50.804,21.03 C48.061,8.082 37.185,0.046 24.173,1.087 C21.967,1.216 19.814,1.641 17.758,2.327 C4.912,6.311 -2.217,18.378 0.618,31.701 C3.597,45.718 16.356,53.931 30.824,50.86 C31.135,50.796 31.441,50.72 31.742,50.645 L41.63,65.864 C43.036,68.204 45.822,69.106 47.857,67.893 L52.602,65.041 C54.642,63.823 55.153,60.94 53.751,58.6 L44.185,43.925 Z M38.752,29.63 C36.718,36.566 29.552,40.715 22.487,38.938 C17.618,37.719 14.038,34.005 12.755,29.496 C12.728,29.378 12.696,29.266 12.674,29.137 C11.074,21.638 15.111,14.718 22.799,13.075 C30.653,11.406 37.158,16.097 38.752,23.596 C39.192,25.684 39.182,27.729 38.752,29.63 Z",
  id: "Shape"
})), /*#__PURE__*/React.createElement("path", {
  d: "M3.071,48.573 L3.071,64.624 C3.071,65.821 4.15,66.89 5.347,66.89 L15.278,66.89 C16.47,66.89 17.543,65.822 17.543,64.624 L17.543,56.094 C17.543,56.094 17.57,54.72 15.686,54.258 C11.649,53.255 6.641,50.082 4.403,47.43 C3.071,45.847 3.071,48.573 3.071,48.573 Z",
  id: "Shape"
})));

var SvgRoomiSmalllogo = function SvgRoomiSmalllogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "68px",
    viewBox: "0 0 55 68",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRoomiSmalllogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/roomi-small.logo.722109d6.svg";
export { ForwardRef as ReactComponent };